import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './Bookmark.styles'

const Bookmark = (props) => {
  const { count, onBookmarkButtonClicked, className, ...rest } = props

  return (
    <Component.Bookmark
      className={ className }
      onClick={ (e) => onBookmarkButtonClicked(e) }
      { ...rest }>
      <Component.BookmarkIcon className='icon-f-bookmarks' />
      <span className='label'>{`Merkliste (${ count })`}</span>
    </Component.Bookmark>
  )
}

Bookmark.defaultProps = {
  count: 0,
}

Bookmark.propTypes = {
  /** Number of bookmarks */
  count: PropTypes.number,
  /** Click Handler */
  onBookmarkButtonClicked: PropTypes.func.isRequired,
  /** custom css class */
  className: PropTypes.string,
}

export default Bookmark
